export default __webpack_public_path__ + "static/media/no-data-available.c796a3d5.svg";